import React from 'react';

const InstagramGlyph = ({ className = 'w-6 h-6' }) => (
  <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
  </svg>
);
const VideoBadge = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
);
const CarouselBadge = () => (
  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M7 7h12a2 2 0 012 2v10a2 2 0 01-2 2H7a2 2 0 01-2-2V9a2 2 0 012-2zm-2-4h12v2H5z" />
  </svg>
);

/**
 * "Follow Our Story" Instagram grid. Photos are copied into the site by
 * scripts/sync-instagram.mjs (run daily), so visitors load nothing from
 * Instagram or any third party until they choose to open a post.
 */
const InstagramFeed = ({ feed, facebookUrl }) => {
  // whole rows of three only
  const posts = feed.posts.slice(0, Math.floor(feed.posts.length / 3) * 3);

  return (
    <section className="py-20 bg-gray-50" aria-labelledby="instagram-heading">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <p className="text-xs font-black uppercase tracking-widest text-[#00213a] mb-1">Stay Connected</p>
          <h2 id="instagram-heading" className="text-4xl font-black text-gray-900">
            Follow Our <span className="text-[#7a5300]">Story</span>
          </h2>
          <p className="text-lg text-gray-600 mt-2">See daily moments from our classrooms, hallways, and community.</p>
          <a
            href={feed.profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-3 px-7 py-3.5 bg-[#00213a] text-white font-black rounded-2xl shadow-lg hover:bg-[#003a5d] hover:-translate-y-0.5 transition-all duration-200"
          >
            <InstagramGlyph />
            Follow @{feed.handle} on Instagram
            <span className="sr-only"> (opens in a new tab)</span>
          </a>
        </div>

        <ul className="grid grid-cols-3 gap-1.5 sm:gap-2">
          {posts.map((post) => (
            <li key={post.id} className="relative aspect-square overflow-hidden bg-gray-200">
              <a
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="group block w-full h-full focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-[#fdbb2e]"
              >
                <img
                  src={post.image}
                  alt={post.alt}
                  width="640"
                  height="640"
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 motion-reduce:transition-none"
                />
                <span className="sr-only"> — view on Instagram{post.type === 'video' ? ' (video)' : post.type === 'carousel' ? ' (multiple photos)' : ''} (opens in a new tab)</span>
                {post.type !== 'image' && (
                  <span className="absolute top-2 right-2 inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#00213a]/85 text-white">
                    {post.type === 'video' ? <VideoBadge /> : <CarouselBadge />}
                  </span>
                )}
              </a>
            </li>
          ))}
        </ul>

        <p className="mt-8 text-center">
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block py-1 text-sm font-bold text-[#00213a] hover:underline"
          >
            Also on Facebook → PS96Lions<span className="sr-only"> (opens in a new tab)</span>
          </a>
        </p>
      </div>
    </section>
  );
};

export default InstagramFeed;
